import styled from 'styled-components'

export default styled.div`
  background: rgba(255, 255, 255, ${props => props.opacity || 0.9});
  box-sizing: border-box;
  text-align: center;
  padding: 200px ${props => props.padWidth || 50}px;
  width: 600px;
`
